const currencyFormatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
});

export const formatCurrency = (amount: number): string => currencyFormatter.format(amount);

export const formatHours = (hours: number, digits = 1): string => `${hours.toFixed(digits)}h`;

const longDateFormatter = new Intl.DateTimeFormat('en-GB', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});

export const formatLongDate = (date: Date): string => longDateFormatter.format(date);

/** "April 2026" / "Apr" for a calendar year + month (1-12). */
export const formatMonth = (year: number, month: number, style: 'long' | 'short' = 'long'): string =>
  new Date(year, month - 1, 1).toLocaleDateString('en-GB', style === 'long' ? { month: 'long', year: 'numeric' } : { month: 'short' });

const wholePoundsFormatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  maximumFractionDigits: 0,
});

/** "£1,225" — for summary figures where pennies are noise. */
export const formatWholePounds = (amount: number): string => wholePoundsFormatter.format(amount);
